/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */

export type UpsertGoalDtoSex = typeof UpsertGoalDtoSex[keyof typeof UpsertGoalDtoSex];


export const UpsertGoalDtoSex = {
  male: 'male',
  female: 'female',
} as const;
